<template>
  <div class="page">
    <div class="nav">
      <van-icon name="arrow-left" color="#fff" size="20" @click="$router.back()" />
      <div>{{ $t('grab.history') }}</div>
      <div style="width:20px"></div>
    </div>
    <div v-if="!list.length" class="empty">{{ $t('grab.empty') }}</div>
    <div class="item" v-for="v in list" :key="v.id">
      <img :src="v.goods_pic" alt="">
      <div class="meta">
        <div class="name">{{ v.goods_name }}</div>
        <div class="time">{{ v.addtime }}</div>
        <div class="line">{{ $t('grab.price') }} {{ v.goods_price }}</div>
        <div class="line hot">{{ $t('grab.commission') }} {{ v.commission }}</div>
      </div>
      <div class="st" :class="{ ok: v.status == 1 }">{{ v.status == 1 ? $t('grab.done') : $t('grab.cancel') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { list: [] };
  },
  created() {
    document.title = this.$t('grab.history');
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }
    this.$http({ method: 'get', url: 'grab_history' }).then((res) => {
      if (res.code === 200) this.list = res.data || [];
    });
  },
};
</script>

<style scoped>
.page { min-height: 100vh; background: #f4f5f8; }
.nav { height: 100px; background: #f22678; color: #fff; display: flex; align-items: center; justify-content: space-between; padding: 0 32px; font-weight: 600; font-size: 34px; }
.item { display: flex; margin: 28px 32px; background: #fff; border-radius: 24px; padding: 24px; align-items: center; }
.item img { width: 140px; height: 140px; object-fit: cover; border-radius: 16px; background: #eee; margin-right: 24px; }
.meta { flex: 1; text-align: left; }
.name { font-weight: 700; color: #222; font-size: 30px; }
.time, .line { color: #888; font-size: 24px; margin-top: 8px; }
.line.hot { color: #f22678; }
.st { color: #999; font-size: 24px; margin-left: 12px; }
.st.ok { color: #12a15b; }
.empty { text-align: center; color: #999; padding: 80px 0; font-size: 28px; }
</style>
